import { Directive } from '@angular/core';

@Directive({
  selector: '[appTableHeader]'
})
export class TableHeaderDirective { }